import React from 'react';
import PropTypes from 'prop-types';
import { Interactions } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import { getRouteFromIntent } from '../../services/intentManager';

//Name of Lex ChatBot
export const chatbotName = 'AmiraForTeacher';

class ChatBot extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      isSendingMessage: false,
    }

    this.sendMessageToBot = this.sendMessageToBot.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
  }

  componentDidUpdate(prevProps){
    if(this.props.transcript.final
      && this.props.transcript.interim === this.props.transcript.final
      && prevProps.transcript.interim !== prevProps.transcript.final){
      //If we're done talking
      this.sendMessageToBot();
    }
  }

  getCompositeMessage(data){
    return JSON.parse(data).messages
      .reduce((msgToSend, msg) => `${msgToSend} ${msg.value}`, "");
  }

  getMessage({messageFormat, message}){
    const format = {
      PLAINTEXT: 'plaintext',
      COMPOSITE: 'composite',
      //CUSTOMPAYLOAD: 'custompayload',//<-- Will be used later
    };

    switch (messageFormat.toLowerCase()) {
      case format.PLAINTEXT:
        return message;
      case format.COMPOSITE:
        return this.getCompositeMessage(message);

      //case format.CUSTOMPAYLOAD: //<--- To be implemented later
      default:
        console.warn('ChatBot does not support this format: ', messageFormat);
        return null;
    };
  }

  handleResponse(response){
    if(response.message){
      const params = {
        textToSpeak: this.getMessage(response),
      };
      if(params.textToSpeak != "Sorry, can you please repeat that?") {
        this.props.speech.speak(params, false);
      }
    }

    if(response.dialogState == 'ElicitIntent'){
      !this.props.speech.isListening && this.props.speech.startListening();
    }

    //Determine if we need to Redirect!
    if(response.intentName && response.dialogState != 'ElicitSlot'){
      //We handle this intent directly on the ChatBot
      if(response.intentName.toLowerCase() == 'goback'){
        return this.props.history.goBack();
      }

      //getRouteFromIntent will return the path that we need to redirect
      //or null if we do not wish to redirect.
      const route = getRouteFromIntent(response);
      //If we have a route,  we stop listening and then we change routes
      if(route){
        window.setTimeout(() => this.props.history.push(route), 100);
      }
    }
  }

  sendMessageToBot(){
    if(!this.state.isSendingMessage) {
      this.setState(
        { isSendingMessage: true },
        () => {
          Interactions.send(chatbotName, this.props.transcript.final)
            .then((resp) => {
              this.handleResponse(resp);
              this.setState({
                isSendingMessage: false ,
              });
            })
            .catch(err => {
              console.error(err);
              this.setState({
                isSendingMessage: false ,
              });
            });
          this.props.speech.resetTranscript();
        }
      );
    }
  }

/*
** NOTE: Leaving this here for future reference, for the moment the ChatBot will only be used
** in Teacher App.
  handleClick(){
    if(!this.props.speech.isSpeaking){//Only respond if we're not speaking
      if(this.props.speech.isListening && !this.props.isReaderActive){
        this.props.speech.stopListening();
      }else{
        //If we (chatbot) want to listen and ReaderManager is listening
        //we mute ReaderManager and abort the speech.
        if(this.props.isReaderActive){
          this.props.speech.abortSpeech();
          this.props.muteReader();
        }
        //Erase Transcript and start listening again
        this.props.speech.resetTranscript();
        this.props.speech.startListening();
      }
    }
  }
*/

  render() {
    return null;
  }
}

ChatBot.propTypes = {
  speech: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isReaderActive: PropTypes.bool.isRequired,
  //muteReader: PropTypes.func.isRequired,
  //unMuteReader: PropTypes.func.isRequired,
  transcript: PropTypes.object.isRequired,
  //greetingMsg: PropTypes.string, NOTE: Leaving this here for future implementation
};

export default withRouter(ChatBot);